var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "edit_item_font_size edit_item_font_size_new" },
    [
      _c(
        "el-select",
        {
          staticClass: "ml-12",
          attrs: { placeholder: "请选择", size: "medium" },
          model: {
            value: _vm.result,
            callback: function ($$v) {
              _vm.result = $$v
            },
            expression: "result",
          },
        },
        _vm._l(_vm.$store.state.options.fontSize, function (item) {
          return _c("el-option", {
            key: item.value,
            attrs: { label: item.label, value: item.value },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }